import { IMembershipDefaultsDto } from '../types/state.d';
import { transformRichTextToFRPSummaryDto } from './richStoryPlainText';
import deleteNullKeys from './deleteNullKeys';
import isRichStory from './isRichStory';

const getMembershipDefaultsDto = ({
  story,
  coverPhoto,
  branding: { primaryColor, backgroundColor, backgroundImage },
}: IMembershipDefaultsDto) =>
  deleteNullKeys({
    pageStory: isRichStory(story)
      ? transformRichTextToFRPSummaryDto(story)
      : story,
    backgroundColour: backgroundColor,
    buttonColour: primaryColor,
    buttonsThermometerFill: primaryColor,
    titleColour: primaryColor,
    pageBackground: backgroundImage,
    coverPhoto,
  });

export default getMembershipDefaultsDto;
